import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAVKlYeZuQ2aDQasN1ERUZz3-yXlsrhHZs",
    libraries: "places",
  },
});
